import React from "react";
import { useNavigate } from "react-router-dom";
import "./Logout.css";  

function Logout({ onClose }) {  
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear local storage
    localStorage.removeItem("authToken");
    localStorage.removeItem("currentUser");

    // Navigate to login
    navigate("/", { replace: true });
  };

  const handleCancel = () => {
    if (onClose) onClose();
  };

  return (
    <div className="logout-overlay">
      <div className="logout-box">
        <h2 className="logout-title">Logout</h2>
        <p className="logout-text">Are you sure you want to logout?</p>
        <div className="logout-buttons">
          <button className="admin-cancel-btn" onClick={handleCancel}>
            Cancel
          </button>
          <button className="admin-logout-btn" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
    </div>
  );
}

export default Logout;
